import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import { computed } from "@vue/reactivity";
import useConvertTimeStrToMinutes from "@/use/useConvertTimeStrToMinutes";
import { ITurn } from "@/domain/entities/lineInfo";
import dayjs from "dayjs";
import getBusStopsByDate from "@/use/useGetBusStopsByDate";


const __default__ = {
  name: "TimeTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  turns: {
    type: Array as PropType<ITurn[]>,
    required: true,
  },
  nextBusStopChangeDateTime: {
    type: String,
    default: dayjs().format("YYYY-MM-DD HH:mm"),
  },
},
  emits: ["onClickCloseBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const departureTimes = computed(() => {
  const departureTimes: string[] = [];

  props.turns.forEach((turn) => {
    const busStops = getBusStopsByDate(turn, props.nextBusStopChangeDateTime);
    if (busStops.length) {
      departureTimes.push(busStops[0].departureTime);
    }
  });

  return departureTimes;
});

const sortedDepartureTimeSchedule = computed(() => {
  return departureTimes.value.sort(
    (a, b) => useConvertTimeStrToMinutes(a) - useConvertTimeStrToMinutes(b)
  );
});

const departureTimeByHour = computed(() => {
  const timesByHour: Record<number, string[]> = {};

  sortedDepartureTimeSchedule.value.forEach((time) => {
    const [hourStr, minute] = time.split(":");
    const hour = Number(hourStr);
    if (!timesByHour[hour]) {
      timesByHour[hour] = [];
    }
    timesByHour[hour].push(time);
  });

  // 숫자로 정렬 후, padStart를 이용해 "07"과 같은 형식 유지
  return Object.keys(timesByHour)
    .map(Number)
    .sort((a, b) => a - b)
    .map((hour) => ({
      hour: hour.toString().padStart(2, "0"),
      minutes: timesByHour[hour],
    }));
});

const __returned__ = { props, emit, departureTimes, sortedDepartureTimeSchedule, departureTimeByHour }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})